import { Component, OnInit, ChangeDetectionStrategy, OnDestroy, ChangeDetectorRef, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AsamcoUserService } from '@asamco/base';
import { ParameterType } from '@asamco/management-portal/shared';
import { showErrorSwal } from '@asamco/utils';
import { BehaviorSubject, Observable, of, Subject } from 'rxjs';
import { takeUntil, tap } from 'rxjs/operators';
import Swal from 'sweetalert2';
import { ApplicationParams } from '../interfaces/application-login-params.interface';
import { ApplicationLogin } from '../interfaces/application-login.interface';
import { ApplicationTypeParameterLogin } from '../interfaces/application-type-param-login.interface';
import { Application } from '../interfaces/application.interface';
import { EntityFilter } from '../interfaces/entity-filter.interface';
import { FilterOptions } from '../interfaces/filter-options.interface';
import { RawLoginPackage } from '../interfaces/raw-login-package.interface';
import { ApplicationService } from '../services/application.service';
import { IntegrationTesterService } from '../services/integration-tester.service';
import { PrettyJsonViewerComponent } from './pretty-json-viewer/pretty-json-viewer.component';
import { DxoFilterRowModule, DxoSearchPanelModule, DxoColumnChooserModule } from 'devextreme-angular/ui/nested';
import { DxSelectBoxModule, DxSwitchModule, DxNumberBoxModule, DxTextAreaModule, DxTextBoxModule, DxDataGridModule } from 'devextreme-angular';
import { NgIf, NgFor, AsyncPipe } from '@angular/common';

@Component({
    selector: 'app-shell-integration-tester',
    templateUrl: './integration-tester.component.html',
    styleUrls: ['./integration-tester.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [NgIf, DxSelectBoxModule, DxSwitchModule, FormsModule, ReactiveFormsModule, DxNumberBoxModule, DxTextAreaModule, NgFor, DxTextBoxModule, PrettyJsonViewerComponent, DxDataGridModule, DxoFilterRowModule, DxoSearchPanelModule, DxoColumnChooserModule, AsyncPipe]
})
export class IntegrationTesterComponent implements OnInit, OnDestroy {
  @ViewChild("jsoncomponent", { static: false }) prettyJsonComponent: PrettyJsonViewerComponent;
  @ViewChild("picklistcomponent", { static: false }) prettyJsonComponentpicklist: PrettyJsonViewerComponent;

  public isAdminSubject = new BehaviorSubject<{ value: boolean }>({ value: undefined });
  public isAdminObservable = this.isAdminSubject.asObservable();

  integrationDataSource: Observable<Application[]>;
  entityTypeDataSource: Observable<string[]>;
  applicationLoginsDataSource: Observable<any[]>;
  retrievingData = new BehaviorSubject<string>("false")
  retrievingData$ = this.retrievingData.asObservable();

  entityCount = new BehaviorSubject<number>(0);

  queryResultDataSource$: Observable<any[]> = new Observable<any[]>();

  picklistSubject: BehaviorSubject<any> = new BehaviorSubject<any>([]);

  picklistResult$: Observable<any[]> = this.picklistSubject.asObservable();

  applicationTypeForm: FormGroup;
  currentId: number = 0;
  queryString: string = null;

  currentSelectedEntity: any;

  parameterTypes: any[];

  filterOptions$ = new Observable<FilterOptions[]>()

  rawLogin: ApplicationLogin = undefined;


  private destroy$ = new Subject<void>();
  usesLoginCredentials: boolean = false;

  objectFields: any[] = [];

  //selectedIntegration: any = undefined;
  public formGroup: FormGroup = new FormGroup({ id: new FormControl(null), applicationId: new FormControl(15) })

  currentSelectedApplicationId = new BehaviorSubject<number>(undefined);
  currentSelectedApplicationId$ = this.currentSelectedApplicationId.asObservable();

  selectedLoginId: number = -1;

  loadingConnectionTest = new BehaviorSubject<string>('enabled');
  loadingConnectionTest$ = this.loadingConnectionTest.asObservable();

  applicationParams: ApplicationParams = {
    fieldName: '',
    defaultValue: '',
    oAuth: false
  };
  /** Subject used for tracking changes, so that the UI gets updated using async */
  applicationParamsChange$ = new Subject<any>();

  isEncrypted: boolean = false;

  constructor(private asamcoUserService: AsamcoUserService, private applicationService: ApplicationService, private integrationTesterService: IntegrationTesterService, private formBuilder: FormBuilder) {
  }

  addLoginField(applicationId: number) {
    this.formGroup.addControl(
      'from',
      new FormGroup({ id: new FormControl(null), applicationId: new FormControl(applicationId) })
    );
  }


  ngOnInit(): void {
    this.asamcoUserService.isAdmin().then(result => { this.isAdminSubject.next({ value: result }); if (result) { this.loadData(); } });
    this.applicationParams.parameters = [];
    this.clearFormAndParams();

    this.applicationParamsChange$.pipe(takeUntil(this.destroy$)).subscribe(e => {
      if (e.toDelete) {
        this.applicationParams.parameters = this.applicationParams.parameters.filter(item => item.id !== e.item);
      } else {
        this.applicationParams = e.item;
      }
    });

  }



  clearFormAndParams() {
    this.applicationTypeForm = this.formBuilder.group({});
    this.applicationParams = {
      parameters: new Array<ApplicationTypeParameterLogin>(),
      applicationType: '',
    } as ApplicationParams;
  }


  onIntegrationValueChanged(event) {
    if (this.currentSelectedApplicationId.value != event.value) {
      this.selectedLoginId = -1;
      this.getAllEntities(event.value);
      //this.selectedIntegration = event.value;
      this.usesLoginCredentials = false;
      this.addLoginField(this.currentSelectedApplicationId.value);
      this.filterOptions$ = this.integrationTesterService.getFilterOptions(event.value);
      this.currentSelectedApplicationId.next(event.value);
    }
  }

  onLoginChanged(e) {
    this.selectedLoginId = e.value;
  }

  showJsonComponent() {
    this.prettyJsonComponent.toggleModal(true);
  }

  testAdminLogin() {
    if (this.selectedLoginId > 0) {
      const appLogin: ApplicationLogin = {
        id: this.selectedLoginId,
        applicationId: this.currentSelectedApplicationId.value,
        name: '',
        userId: 99999,
      }
      this.loadingConnectionTest.next('disabled');
      this.integrationTesterService.canLogin(appLogin).subscribe(e => {
        this.loadingConnectionTest.next('enabled');
        Swal.fire({ title: "Successfully connected", timer: 2000, icon: 'success' })
      }, error => { this.loadingConnectionTest.next('enabled'); showErrorSwal(error) })
    }
    else {
      Swal.fire({ title: "Please select a login" })
    }

  }

  loadData() {
    this.getAllApplications();

  }

  getAllApplications() {
    this.integrationDataSource = this.applicationService.get().pipe(tap(result => result.sort((a, b) => (a.name > b.name) ? 1 : ((b.name > a.name) ? -1 : 0))))
  }

  setRawLogin(items: RawLoginPackage) {
    if (items) {
      console.log(items.applicationLogin)
      console.log(items.isEncrypted)
      this.rawLogin = items.applicationLogin;
      this.isEncrypted = items.isEncrypted;
      Swal.fire({ title: "Successfully authenticated", icon: 'success' })
    }
    else {
      Swal.fire({ title: "Unable to authenticate", icon: 'error' })
    }

  }


  sendRequest() {

    let list: number[] = [];

    var listOfLists: EntityFilter[] = [];

    for (const key in this.applicationTypeForm.value) {

      var index = key.substring(0, key.indexOf('_'));
      const found = list.filter(item => item == Number(index))

      //Check if we already created an object so we can either: create a new one for this index, or change the properties of the existing one
      if (found.length > 0) {
        //Check if the current value is the following key
        if (key.indexOf('_defaultValue') > -1) {
          listOfLists = listOfLists.map(item => item.Identifier == Number(index) ? { ...item, Value: this.applicationTypeForm.get(key).value } : item)
        }
        else if (key.indexOf('_name') > -1) {
          listOfLists = listOfLists.map(item => item.Identifier == Number(index) ? { ...item, EntityName: this.applicationTypeForm.get(key).value } : item)
        }
        else if (key.indexOf('_type') > -1) {
          listOfLists = listOfLists.map(item => item.Identifier == Number(index) ? { ...item, ExpressionType: this.applicationTypeForm.get(key).value.expressionValue } : item)
        }
      }
      else {
        list.push(Number(index))
        let newFilter: EntityFilter = { EntityName: "", Identifier: Number(index), ExpressionType: "", Value: "" }
        listOfLists.push(newFilter)

        if (key.indexOf('_defaultValue') > -1) {
          listOfLists = listOfLists.map(item => item.Identifier == Number(index) ? { ...item, Value: this.applicationTypeForm.get(key).value } : item)
        }
        else if (key.indexOf('_name') > -1) {
          listOfLists = listOfLists.map(item => item.Identifier == Number(index) ? { ...item, EntityName: this.applicationTypeForm.get(key).value } : item)
        }
        else if (key.indexOf('_type') > -1) {
          console.log(this.applicationTypeForm.get(key).value);
          listOfLists = listOfLists.map(item => item.Identifier == Number(index) ? { ...item, ExpressionType: this.applicationTypeForm.get(key).value.expressionValue } : item)
        }
      }
    }

    let appLogin: ApplicationLogin = undefined;
    let isRawLogin: boolean = false;
    let isEncrypted: boolean = false;
    if (this.usesLoginCredentials) {
      appLogin = this.rawLogin;
      isRawLogin = true;
      isEncrypted = this.isEncrypted;
    }
    else {
      appLogin = {
        id: this.selectedLoginId,
        applicationId: this.currentSelectedApplicationId.value,
        name: '',
        userId: 99999,
      }
    }

    if (this.queryString && this.selectedLoginId) {
      this.retrievingData.next('true');
      this.integrationTesterService.retrieveRawData(appLogin, this.queryString, this.entityCount.value).subscribe(e => {
        this.retrievingData.next('false');
        this.queryResultDataSource$ = of(e);
      }, err => {
        showErrorSwal(err)
        this.retrievingData.next('false');
      })
    }
    else if (this.currentSelectedEntity && this.selectedLoginId) {
      this.retrievingData.next('true');
      this.integrationTesterService.retrieveData(appLogin, this.currentSelectedEntity, listOfLists, this.entityCount.value, isEncrypted, isRawLogin).subscribe(e => {
        this.retrievingData.next('false');
        this.queryResultDataSource$ = of(e);
      }, err => {
        showErrorSwal(err)
        this.retrievingData.next('false');
      })
    }
    else {
      Swal.fire({ title: "Please select an entity", timer: 2000 })
    }
  }

  getPickList() {


    const appLogin: ApplicationLogin = {
      id: this.selectedLoginId,
      applicationId: this.currentSelectedApplicationId.value,
      name: '',
      userId: 99999,
    }

    Swal.fire({
      title: 'Get picklist values',
      text: 'Enter property name of object to retrieve value from',
      input: 'text',
      inputAttributes: {
        autocapitalize: 'off'
      },
      showCancelButton: true,
      confirmButtonText: 'Look up',
      showLoaderOnConfirm: true,
      preConfirm: (objectName) => {
        this.integrationTesterService.getPickList(appLogin, objectName)
          .subscribe(response => {
            this.picklistSubject.next(response);
            this.prettyJsonComponentpicklist.toggleModal(true);
          }, error => {
            Swal.showValidationMessage(
              `Request failed: ${error}`
            )
          })
      },
      allowOutsideClick: () => !Swal.isLoading()
    })
  }

  updateRawQueryContent(e) {
    this.queryString = e.value;
  }

  changedResultLimit(e) {
    this.entityCount.next(e.value)
  }

  changeSelectedEntity(e) {
    this.currentSelectedEntity = e.value;

    this.integrationTesterService.getFieldProperties(this.currentSelectedEntity.assemblyName).subscribe(e => this.objectFields = e)
    //console.log(this.currentSelectedEntity)
  }

  //TODO: Add entity retrieval based on integration
  getAllEntities(integrationId: number) {
    this.entityTypeDataSource = this.integrationTesterService.getFields(integrationId);
    this.applicationLoginsDataSource = this.integrationTesterService.getAdminLogins(integrationId);
  }

  addParameter() {
    this.currentId++;
    this.applicationParams.parameters.push({
      id: this.currentId,
      type: ParameterType.String,
      isRequired: false,
      hidden: false,
      fieldName: null,
      richText: '',
      defaultValue: null,
    } as ApplicationTypeParameterLogin);
    const newParam = this.applicationParams.parameters[this.applicationParams.parameters.length - 1];
    this.applicationTypeForm.addControl(this.currentId + '_type', new FormControl(newParam.type, Validators.required));
    this.applicationTypeForm.addControl(this.currentId + '_name', new FormControl(newParam.name, Validators.required));
    this.applicationTypeForm.addControl(this.currentId + '_defaultValue', new FormControl(newParam.defaultValue));
    this.applicationTypeForm.addControl(this.currentId + '_fieldName', new FormControl(newParam.fieldName, Validators.required));
    this.applicationTypeForm.addControl(this.currentId + '_richText', new FormControl(newParam.richText));
  }

  removeParameter(id: number) {
    this.applicationParamsChange$.next({ item: id, toDelete: true });
    //this.applicationParams.parameters = this.applicationParams.parameters.filter(item => item.id !== id);
    this.applicationTypeForm.removeControl(id + '_type');
    this.applicationTypeForm.removeControl(id + '_name');
    this.applicationTypeForm.removeControl(id + '_defaultValue');
    this.applicationTypeForm.removeControl(id + '_fieldName');
    this.applicationTypeForm.removeControl(id + '_richText');

  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }


}
